<template>
  <!--新增对话框-->
  <el-dialog
    title="编辑常量数据配置"
    :visible.sync="dialogVisible"
    width="800px"
    append-to-body
    :close-on-click-modal="false"
    :before-close="handleClose"
  >
    <el-form
      :model="editForm"
      :rules="editFormRules"
      ref="editForm"
      label-width="100px"
      class="demo-editForm"
    >
      <el-form-item label="类型描述" prop="describe" label-width="100px">
        <el-input v-model="editForm.describe" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="类型值" prop="value" label-width="100px">
        <el-time-picker
          v-model="editForm.value"
          autocomplete="off"
          v-if="editForm.type == 'DEADLINE_OF_THE_PARK'"
          value-format="HH:mm:ss"
        >
        </el-time-picker>
        <el-input
          v-model="editForm.value"
          autocomplete="off"
          v-else-if="editForm.type != 'DEADLINE_OF_THE_PARK'"
        ></el-input>
      </el-form-item>
      <!-- <el-form-item label="类型值" prop="value" label-width="100px">
                <el-input v-model="editForm.value" autocomplete="off"></el-input>
            </el-form-item> -->
      <el-form-item>
        <el-button type="primary" @click="submitForm('editForm')"
          >立即创建</el-button
        >
        <el-button @click="resetForm('editForm')">重置</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
export default {
  name: "UpdateConfigType",
  data() {
    return {
      editForm: {},
      fileList: [],
      editFormRules: {
        value: [{ required: true, message: "请输入类型值", trigger: "blur" }],
      },
      dialogVisible: false,
    };
  },
  methods: {
    change(val) {
      this.editForm.describe = val;
    },
    resetForm(formName) {
      // 防守性调用，避免在 ref 不存在时抛错
      if (this.$refs && this.$refs[formName]) {
        this.$refs[formName].resetFields();
      }
      this.dialogVisible = false;
      this.editForm = {};
      this.fileList = [];
    },
    // Element UI before-close 回调接收一个 done() 回调，调用 done() 以继续关闭
    handleClose(done) {
      this.resetForm("editForm");
      if (typeof done === "function") done();
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        console.log("valid", valid);
        if (valid) {
          this.$axios
            .post("/admin/configType/updConfigType", this.editForm)
            .then((res) => {
              this.$message({
                showClose: true,
                message: "恭喜你，操作成功",
                type: "success",
                onClose: () => {
                  this.$emit("refreshDataList");
                },
              });
              this.dialogVisible = false;
              this.resetForm(formName);
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    getImgList(url, add) {
      if (add == 1) {
        this.editForm.value = url;
      } else if (add == 0) {
        this.editForm.value = "";
      }
    },
    init(id) {
      this.dialogVisible = true;
      if (id != null && id != "") {
        this.$axios
          .post("/admin/configType/getConfigTypeInfo", { id: id })
          .then((res) => {
            this.editForm = res.data;
            var filess = { url: res.data.value };
            // 初始化时直接替换，避免多次打开累积
            this.fileList = [filess];
          });
      }
    },
  },
};
</script>

<style scoped></style>
